/* eslint-disable no-underscore-dangle */

const _getPlatformFromId = (id, allPlatforms = []) => {
  const platform = allPlatforms.filter(p => p.id === id)[0];
  let requiredCredentials = [];
  try {
    requiredCredentials = JSON.parse(platform.required_credentials);
  } catch (e) {
    requiredCredentials = [];
  }

  return { ...platform, required_credentials: requiredCredentials };
};

const _normalizeDeployment = (deployment, meta) => {
  if (!deployment.platformId) return null;
  const platform = _getPlatformFromId(deployment.platformId, meta.allPlatforms);
  const normalizedDeployment = {
    callback_url: deployment.callbackURL,
    platform_id: deployment.platformId,
    business_id: deployment.businessId || meta.businessId,
    client_id: deployment.clientId,
    id: deployment.id,
    active: deployment.active,
    credentials: {},
  };

  platform.required_credentials.forEach(requiredCredential => {
    const credKey = requiredCredential.name;
    normalizedDeployment.credentials[credKey] = deployment[credKey];
  });

  return normalizedDeployment;
};

const normalizeToDeploymentsAPI = (data, meta) => {
  const { partnerSpecificSettings: pss } = data;
  const deployments = [];
  Object.keys(pss.settingsIndexed || {}).forEach(partner => {
    const { platformDeployments } = pss.settingsIndexed[partner];
    Object.keys(platformDeployments).forEach(deployId => {
      const deployment = platformDeployments[deployId];
      const normalizedDeployment = _normalizeDeployment(deployment, meta);
      if (normalizedDeployment) deployments.push(normalizedDeployment);
    });
  });

  return deployments;
};

export default normalizeToDeploymentsAPI;
